import { z } from 'zod'

/**
 * Inbound webhook payload (HTTP POST /webhooks/{provider} body). The webhook
 * service is provider-agnostic and stores the payload verbatim, so the body is
 * accepted as an opaque JSON object — provider-specific mapping happens later in
 * the consuming worker, never at the receiver. Signature verification is a
 * header concern handled before this schema.
 */
export const webhookReceiveSchema = z.record(z.string(), z.unknown())

export type WebhookReceiveInput = z.infer<typeof webhookReceiveSchema>
